// A minimal way for any page to open the floating Prompta chat (Chatbot) with
// a question already typed in. The Chatbot owns its own open/input state, so
// this is a window event it listens for rather than shared state: the caller
// needs no handle on it, and nothing happens when no Chatbot is mounted.
export const OPEN_PROMPTA_CHAT = 'prompta:open-chat';

// Open the chat; `question`, when given, replaces whatever is in its input.
export const openPromptaChat = (question = '') => {
    window.dispatchEvent(new CustomEvent(OPEN_PROMPTA_CHAT, { detail: { question } }));
};
